var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 24.5002L19.4334 19.4334M19.4334 19.4334C20.3001 18.5667 20.9876 17.5378 21.4567 16.4054C21.9257 15.273 22.1671 14.0593 22.1671 12.8336C22.1671 11.6079 21.9257 10.3942 21.4567 9.26177C20.9876 8.12937 20.3001 7.10044 19.4334 6.23374C18.5667 5.36704 17.5378 4.67953 16.4054 4.21048C15.273 3.74142 14.0593 3.5 12.8336 3.5C11.6079 3.5 10.3942 3.74142 9.26177 4.21048C8.12937 4.67953 7.10044 5.36704 6.23374 6.23374C4.48336 7.98413 3.5 10.3582 3.5 12.8336C3.5 15.309 4.48336 17.683 6.23374 19.4334C7.98412 21.1838 10.3582 22.1672 12.8336 22.1672C15.309 22.1672 17.683 21.1838 19.4334 19.4334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.844c69dc877a0355a9b6a6d026480fd9.svg";
export { ForwardRef as ReactComponent };